export const defaultProps = {
  disableColumnSelector: true,
  disableColumnMenu: true,
  showHeader: false,
  showQuickFilter: false,
  gridPagination: false,
  withoutBorderRadius: true,
  pageSize: 5,
};
